import ObjectHTML from './html.object';

export default class LayerHTML {

  constructor() {
    this.htmlLayerElements = [];
    this.domElement = document.createElement('div');
  }

  add(object) {
    if (object instanceof ObjectHTML) {
      this.htmlLayerElements.push(object);
      this.addHTML(object.domElement);
    } else {
      throw new Error('Object should be instance of ObjectHTML');
    }
  }

  addLayer(layer) {
    if (layer instanceof LayerHTML) {
      for (let i = 0; i < layer.htmlLayerElements.length; i++)
        this.add(layer.htmlLayerElements[i]);

      // VladP: the tree structure will be different by using the code below
      // this.htmlLayerElements.push(...layer.htmlLayerElements);
      // this.addHTML(layer.domElement);
    } else {
      throw new Error('Layer should be instance of LayerHTML');
    }
  }

  addHTML(object) {
    if (object instanceof HTMLElement) {
      this.domElement.appendChild(object);
    } else {
      throw new Error('Object should be instance of HTMLElement');
    }
  }

  render(camera, renderer) {
    if (this.htmlLayerElements.length) {
      this.htmlLayerElements.forEach((item) => {
        item.render(camera, renderer);
      });
    }
  }

  clear() {
    // VladP: Remove elements from the DOM to prevent a memory leak
    for (let i = 0; i < this.htmlLayerElements.length; i++)
      if (this.domElement.contains(this.htmlLayerElements[i].domElement))
        this.domElement.removeChild(this.htmlLayerElements[i].domElement);
    
    this.domElement.innerHTML = '';
    this.htmlLayerElements = [];
  }

  show() {
    this.domElement.style.display = 'block';
  }

  hide() {
    this.domElement.style.display = 'none';
  }

}



// WEBPACK FOOTER //
// ./src/object-view/misc/html/html.layer.js